import { useLazyQuery } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { GET_STANDARD_ITEM } from '../../services/data-store.gql';
import Breadcrumbs from '../../widgets/breadcrumbs';
import Notification from '../../widgets/notification';
import usePageNotification from '../../utilities/notification/use-page-notification';
import './standard-item-detail.scss';
import AssociationTable from './standard-item-equipment-association-table';
import StandardItemProvider from './standard-item-provider';
import AssociationMessages from './standard-item-equipment-messages';
import StandardItemPageTitle from './standard-item-page-title';
import StandardItemInfo from './standard-item-info';

const StandardItemDetail = () => {
  const location = useLocation();
  const [passedData, setPassedData] = useState(location.state);

  const [, setError] = useState({});
  const notification = usePageNotification();
  const pageParams = useParams();

  const [getStandardItem] = useLazyQuery(GET_STANDARD_ITEM, {
    fetchPolicy: 'network-only',
    onCompleted: (responseData) => {
      if (responseData?.getStandardItem) {
        setPassedData(responseData.getStandardItem);
      }
    },
    onError: (responseError) => {
      setError((prev) => ({ ...prev, GET_STANDARD_ITEM: responseError }));
    },
  });

  // Called only if user loads page at /standard-item/:key
  // i.e.: user didn't start from standard items table => Manage Equipment Codes.
  const loadData = () => {
    const { key } = pageParams;

    if (!key) return;

    const [standardItemNumber, year] = key.split('-');
    // Invalid param so don't try to fetch data.
    if (!standardItemNumber.length || !year.length) return;

    getStandardItem({
      variables: {
        filter: {
          operator: 'AND',
          value: [
            {
              operator: 'EQ',
              key: 'standardItemNumber',
              value: standardItemNumber,
            },
            { operator: 'EQ', key: 'year', value: year },
          ],
        },
      },
    });
  };

  useEffect(() => {
    loadData();
  }, [location.state]);

  const breadcrumbsPath = [
    {
      location: `${window.AFP_CONFIG.appURLs.home}/home`,
      label: 'Home',
    },
    {
      location: '/catalog/standard-items',
      label: 'Standard items',
    },
  ];

  return (
    <StandardItemProvider selected={passedData}>
      <div className="grid-col">
        <Breadcrumbs path={breadcrumbsPath} current="Standard Items detail" />
        <AssociationMessages />
        {notification ? <Notification {...notification} /> : null}
        <StandardItemPageTitle />
        {passedData && <StandardItemInfo />}
        <AssociationTable />
      </div>
    </StandardItemProvider>
  );
};

export default StandardItemDetail;
